import { inject } from "vue";
import { logEvent } from "~/utils/firebase";
import { getChannel } from "~/utils/getChannel";

const TEACHER_UID_STORAGE_KEY = "pending_chat_teacher_uid";

export function useMasterFortuneTeacherNav() {
	const openLoginPopup = inject("openLoginPopup", null);

	function toTeacherDetail(teacherUid) {
		if (!teacherUid) return;
		navigateTo(`/seer/teacher-detail/${teacherUid}`);
	}

	function toChat(teacherUid) {
		if (!teacherUid) return;

		if (import.meta.client) {
			logEvent("gw_to_free_chat_click", {
				channel: getChannel(),
			});

			if (!localStorage.getItem("token")) {
				localStorage.setItem(TEACHER_UID_STORAGE_KEY, teacherUid);
			}
		}

		const targetUrl = `/seer/chat/${teacherUid}`;

		if (!openLoginPopup) {
			navigateTo(targetUrl);
			return;
		}

		openLoginPopup(() => {
			if (import.meta.client) {
				localStorage.removeItem(TEACHER_UID_STORAGE_KEY);
			}
			navigateTo(targetUrl);
		}, false);

		if (import.meta.client && localStorage.getItem("token")) {
			navigateTo(targetUrl);
		}
	}

	return {
		toChat,
		toTeacherDetail,
	};
}
